import React from 'react';
import './AgendaRed.css';

function AgendaRed({ data }) {
  const row = data?.table?.rows?.[0]?.c;

  const hasEvent = Boolean(row?.[1]?.v);
  const date = row?.[0]?.v ? formatDate(row[0].v) : '';

  if (!hasEvent) {
    return (
      <section className="agenda-red agenda-red--empty">
        <h3>Atualizações em breve!</h3>
        <p>
          Nos acompanhe também pelo Instagram:{' '}
          <a
            href="https://www.instagram.com/maracajudegaveta/"
            target="_blank"
            rel="noreferrer"
          >
            @maracajudegaveta
          </a>
        </p>
      </section>
    );
  }

  return (
    <section className="agenda-red">
      <div className="agenda-red-row">
        <span className="agenda-red-date">{date}</span>
        <span className="agenda-red-place">{row[1].v}</span>
        <button onClick={() => window.open('/agenda', '_blank')}>
          Saiba mais
        </button>
      </div>
    </section>
  );
}

function formatDate(value) {
  if (!value) return '';

  const match = value.match(/Date\((\d+),(\d+),(\d+)\)/);
  if (!match) return '';

  const [, year, month, day] = match;
  return new Date(year, month, day).toLocaleDateString('pt-BR');
}

export default AgendaRed;
